import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentLayout1Component } from '@components/content/components/content-layout-1';
import { ContentLayout10Component } from '@components/content/components/content-layout-10';
import { ContentLayout11Component } from '@components/content/components/content-layout-11';
import { ContentLayout12Component } from '@components/content/components/content-layout-12';
import { ContentLayout13Component } from '@components/content/components/content-layout-13';
import { ContentLayout2Component } from '@components/content/components/content-layout-2';
import { ContentLayout3Component } from '@components/content/components/content-layout-3';
import { ContentLayout4Component } from '@components/content/components/content-layout-4';
import { ContentLayout5Component } from '@components/content/components/content-layout-5';
import { ContentLayout6Component } from '@components/content/components/content-layout-6';
import { ContentLayout7Component } from '@components/content/components/content-layout-7';
import { ContentLayout8Component } from '@components/content/components/content-layout-8';
import { ContentLayout9Component } from '@components/content/components/content-layout-9';
import { ContentLayout } from '@components/content/config';
import { ComponentLoaderAbstract } from '@services/component-loader';
import { Layout } from '@shared/models';

@Component({
  selector: 'app-content',
  imports: [
    ContentLayout1Component,
    ContentLayout2Component,
    ContentLayout3Component,
    ContentLayout4Component,
    ContentLayout5Component,
    ContentLayout6Component,
    ContentLayout7Component,
    ContentLayout8Component,
    ContentLayout9Component,
    ContentLayout10Component,
    ContentLayout11Component,
    ContentLayout12Component,
    ContentLayout13Component,
  ],
  templateUrl: './content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentComponent extends ComponentLoaderAbstract<Layout<ContentLayout>> {
  readonly layout = ContentLayout;
}
